import "./App.css";
import data from "./data.js";
import {useState} from "react";
// 라우터
import {Routes, Route, useNavigate} from "react-router-dom";
// 부트스트랩 가져오기 한줄 입력
import {Navbar, Nav, Container} from "react-bootstrap";

import Home from "./routes/Home";
import About from "./routes/About";
import Detail from "./routes/Detail";
import Cart from "./routes/Cart";

function App() {
  let [res, setRes] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8]);
  let [shoes, setShoes] = useState(data);
  let navigate = useNavigate();

  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href="/">슈마커</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate("/Detail/0");
              }}
            >
              Detail
            </Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate("/About");
              }}
              className="About"
            >
              About
            </Nav.Link>
            <Nav.Link href="#pricing">Pricing</Nav.Link>
            <Nav.Link
              onClick={() => {
                navigate("/cart");
              }}
            >
              Order
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <Routes>
        <Route path="/" element={<Home shoes={shoes} setShoes={setShoes} res={res} setRes={setRes}></Home>} />
        <Route path="/detail/:id" element={<Detail shoes={shoes} />} />
        <Route path="/about" element={<About />}>
          <Route path="member" element={<div>멤버입니다.</div>} />
          <Route path="location" element={<div>위치입니다.</div>} />
        </Route>
        <Route path="*" element={<div>없는 페이지입니다.</div>} />
        <Route path="/cart" element={<Cart />} />
      </Routes>
      {/* 푸터  */}
      <Footer />
    </>
  );
}
function Footer() {
  let fcss = {
    backgroundColor: "#333",
    color: "#fff",
    padding: "20px,0",
    marginTop: "80px",
    padding: "10px",
    marginBottom: "0",
  };
  return <p style={fcss}>COPYRIGHT(C) 2022 Nike, Inc. All Rights Reserved</p>;
}
export default App;
